var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.884 0.532004C10.538 -0.121996 9.46196 -0.121996 9.11596 0.532004L0.115959 17.532C0.0349422 17.6844 -0.00522229 17.8551 -0.000621372 18.0276C0.00397955 18.2001 0.0531889 18.3685 0.142212 18.5164C0.231235 18.6642 0.357036 18.7864 0.507356 18.8712C0.657676 18.956 0.827389 19.0003 0.999959 19H19C19.1724 19.0004 19.342 18.956 19.4922 18.8713C19.6424 18.7866 19.7681 18.6644 19.8571 18.5167C19.946 18.3689 19.9951 18.2006 19.9997 18.0282C20.0042 17.8559 19.964 17.6852 19.883 17.533L10.884 0.532004ZM11 16H8.99996V14H11V16ZM8.99996 12V7H11L11.001 12H8.99996Z",
    fill: "#FCC046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.19acfacefcd9aa263b95d77fdd0fea29.svg";
export { ForwardRef as ReactComponent };